/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
      this.drawer.removeAttribute('inert');
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);


/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains('facets--sidebar-open') ? hideFilters : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);

/**
 *  @class
 *  @function MoreFilters
 */
class MoreFilters extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (e) => {
      let ul = this.closest('.thb-filter-content').querySelector('ul');

      if (ul.hasAttribute('filters-open')) {
        this.textContent = theme.strings.showMore;
        ul.removeAttribute('filters-open');
      } else {
        this.textContent = theme.strings.showLess;
        ul.setAttribute('filters-open', '');
      }
      e.preventDefault();
    });
  }
}
customElements.define('more-filters', MoreFilters);

function getFacetsBarStickyTop() {
  const rootStyles = getComputedStyle(document.documentElement);
  const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
  const headerOffset = parseFloat(rootStyles.getPropertyValue('--header-offset')) || 0;
  return headerHeight + headerOffset;
}

function updateFacetsBarInnerHeight() {
  const barInner = document.querySelector('.facets--bar-inner');
  const height = barInner ? barInner.offsetHeight : 56;
  document.documentElement.style.setProperty('--facets-bar-inner-height', height + 'px');
}

function bindFacetsBarStickyState(form) {
  if (!form.classList.contains('facets--bar')) return;

  const barInner = form.querySelector('.facets--bar-inner');
  if (!barInner) return;

  updateFacetsBarInnerHeight();

  if (barInner._facetsStickyCleanup) {
    barInner._facetsStickyCleanup();
  }

  let sentinel = form.querySelector('.facets--bar-sticky-sentinel');
  if (!sentinel) {
    sentinel = document.createElement('div');
    sentinel.className = 'facets--bar-sticky-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    barInner.before(sentinel);
  }

  let ticking = false;

  const updateStuckState = () => {
    updateFacetsBarInnerHeight();
    const isStuck = sentinel.getBoundingClientRect().bottom <= getFacetsBarStickyTop();
    barInner.classList.toggle('facets--bar-inner--stuck', isStuck);
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateStuckState();
      ticking = false;
    });
  };

  updateStuckState();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  barInner._facetsStickyCleanup = () => {
    window.removeEventListener('scroll', onScrollOrResize);
    window.removeEventListener('resize', onScrollOrResize);
    barInner.classList.remove('facets--bar-inner--stuck');
    delete barInner._facetsStickyCleanup;
  };
}

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this._submitTimer = null;

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', (event) => {
        clearTimeout(this._submitTimer);
        this._submitTimer = setTimeout(() => this.onSubmitHandler(event), 500);
      });

      form.addEventListener('change', (event) => {
        if (event.target.name !== 'sort_by') return;
        clearTimeout(this._submitTimer);
        this.onSubmitHandler(event);
      });

      form.addEventListener('click', (event) => {
        if (event.target.closest('[data-price-reset]')) {
          this.onActiveFilterClick(event);
        }
      });
    }
  }

  cancelDebouncedSubmit() {
    clearTimeout(this._submitTimer);
  }

  static cancelAllDebouncedSubmits() {
    document.querySelectorAll('facet-filters-form').forEach((form) => {
      if (form.cancelDebouncedSubmit) form.cancelDebouncedSubmit();
    });
  }

  static stripDefaultPriceParams(searchParams, form) {
    if (!form) return searchParams;

    form.querySelectorAll('price-range-selector').forEach((selector) => {
      const minInput = selector.querySelector('[data-price-min]');
      const maxInput = selector.querySelector('[data-price-max]');
      if (!minInput || !maxInput) return;

      const gteKey = minInput.name;
      const lteKey = maxInput.name;
      const gteVal = searchParams.get(gteKey);
      const lteVal = searchParams.get(lteKey);
      const minDefault = parseFloat(minInput.dataset.min || '0');
      const maxDefault = parseFloat(maxInput.dataset.max || maxInput.placeholder || '0');

      if (gteVal !== null) {
        const gteNum = parseFloat(String(gteVal).replace(',', '.'));
        if (Number.isNaN(gteNum) || gteNum <= minDefault) {
          searchParams.delete(gteKey);
        }
      }

      if (lteVal !== null && !Number.isNaN(maxDefault)) {
        const lteNum = parseFloat(String(lteVal).replace(',', '.'));
        if (Number.isNaN(lteNum) || lteNum >= maxDefault) {
          searchParams.delete(lteKey);
        }
      }
    });

    if (searchParams.get('filter.v.price.gte') === '0.00' || searchParams.get('filter.v.price.gte') === '0') {
      searchParams.delete('filter.v.price.gte');
    }

    const priceSlider = form.querySelector('.price_slider');
    if (priceSlider) {
      const maxDefault = parseFloat(priceSlider.dataset.max);
      const lteVal = searchParams.get('filter.v.price.lte');
      if (lteVal !== null && !Number.isNaN(maxDefault) && parseFloat(lteVal) === maxDefault) {
        searchParams.delete('filter.v.price.lte');
      }
    }

    return searchParams;
  }

  static buildSearchParams(triggerForm) {
    const searchParams = new URLSearchParams();
    const skipKeys = new Set(['compare_toggle']);
    const singleValueKeys = new Set(['sort_by', 'q']);

    const forms = [
      document.querySelector('#FacetFiltersForm'),
      document.querySelector('#FacetFiltersFormMobile'),
      document.querySelector('.facets--bar-left'),
    ].filter(Boolean);

    const orderedForms = forms.filter((form) => form !== triggerForm);
    if (triggerForm) orderedForms.push(triggerForm);

    orderedForms.forEach((form) => {
      for (const [key, value] of new FormData(form).entries()) {
        if (skipKeys.has(key)) continue;

        if (singleValueKeys.has(key)) {
          searchParams.delete(key);
          searchParams.set(key, value);
          continue;
        }

        const existing = searchParams.getAll(key);
        if (!existing.includes(value)) {
          searchParams.append(key, value);
        }
      }
    });

    const priceForm = document.querySelector('#FacetFiltersForm') || triggerForm;
    FacetFiltersForm.stripDefaultPriceParams(searchParams, priceForm);
    return searchParams;
  }

  connectedCallback() {
    bindFacetsBarStickyState(this);
  }

  disconnectedCallback() {
    const barInner = this.querySelector('.facets--bar-inner');
    if (barInner && barInner._facetsStickyCleanup) {
      barInner._facetsStickyCleanup();
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      if (event.state && event.state.lopPlpNavBar) return;
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static syncSidebarResultsClass(parsedHTML) {
    const newSidebar = parsedHTML.getElementById('Sidebar-Container');
    const currentSidebar = document.getElementById('Sidebar-Container');
    if (!newSidebar || !currentSidebar) return;

    [...currentSidebar.classList]
      .filter((className) => className.startsWith('results--'))
      .forEach((className) => currentSidebar.classList.remove(className));

    [...newSidebar.classList]
      .filter((className) => className.startsWith('results--'))
      .forEach((className) => currentSidebar.classList.add(className));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm._renderGeneration = (FacetFiltersForm._renderGeneration || 0) + 1;
    const generation = FacetFiltersForm._renderGeneration;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, generation);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, generation);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, generation) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        if (generation !== FacetFiltersForm._renderGeneration) return;

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, generation) {
    if (generation !== FacetFiltersForm._renderGeneration) return;

    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newProducts = parsedHTML.querySelector('.sidebar-container--products');
    const currentProducts = document.querySelector('.sidebar-container--products');

    if (newProducts && currentProducts) {
      currentProducts.innerHTML = newProducts.innerHTML;
      FacetFiltersForm.syncSidebarResultsClass(parsedHTML);
    } else {
      const container = document.getElementById('ProductGridContainer');
      const newContainer = parsedHTML.getElementById('ProductGridContainer');
      if (container && newContainer) {
        container.innerHTML = newContainer.innerHTML;
      }
    }

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    [
      ['#FacetFiltersForm', '#FacetFiltersForm'],
      ['#FacetFiltersFormMobile', '#FacetFiltersFormMobile'],
    ].forEach(([sourceSelector, targetFormSelector]) => {
      const targetForm = document.querySelector(targetFormSelector);
      if (!targetForm) return;

      parsedHTML.querySelectorAll(`${sourceSelector} collapsible-row`).forEach((element) => {
        const target = targetForm.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`);
        if (target) target.innerHTML = element.innerHTML;
      });
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const parsedHTML = typeof html === 'string'
      ? new DOMParser().parseFromString(html, 'text/html')
      : html;
    const source =
      parsedHTML.querySelector('.facets--bar .active-facets') ||
      parsedHTML.querySelector('.active-facets');
    if (!source) return;

    document.querySelectorAll('.active-facets').forEach((current) => {
      current.outerHTML = source.outerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const searchParams = FacetFiltersForm.buildSearchParams(form);
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.cancelAllDebouncedSubmits();
    FacetFiltersForm.toggleActiveFacets();
    const link = event.target.closest('a') || event.currentTarget;
    const href = link.href || '';
    const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, null);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  connectedCallback() {
    if (this.dataset.removeBound === 'true') return;
    this.dataset.removeBound = 'true';

    this.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      event.preventDefault();

      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form.facets--bar') ||
        document.querySelector('facet-filters-form.facets-desktop-container') ||
        document.querySelector('facet-filters-form');

      if (form && form.onActiveFilterClick) {
        form.onActiveFilterClick(event);
      }
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);